export enum EventType {
    LogEvent,
    TimingEvent
}

export interface LogEvent {
    category?: string,
    action?: string,
    label?: string,
    fbEvent?: string,
    value?: number,
    fieldsObject?: any
}

export interface TimingEvent {
    category: string,
    variable: string,
    value: number, // in milliseconds
    label: string
}
